// `/login` — renders the Manager login form for unauthenticated requests;
// 302s authenticated requests to `/live-in-club`. The `beforeLoad` hook fires
// both on initial SSR and on client-side navigation; the `typeof window`
// early-return short-circuits the client-side path so
// `resolveScopeOnServer` is only invoked on the server (its body — and
// the server-only imports it pulls in — is excluded from the client
// bundle by Tanstack Start's import-protection plugin).

import { createFileRoute, redirect } from '@tanstack/react-router';
import { createServerOnlyFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';
import { getServerAuthService } from '~/bounded-contexts/authentication/composition.server';
import { LoginPage } from '~/bounded-contexts/authentication/ui/login-page/login-page';

const resolveScopeOnServer = createServerOnlyFn(async () =>
	getServerAuthService().resolveTenantScope(getRequest()),
);

export const Route = createFileRoute('/login')({
	beforeLoad: async () => {
		if (typeof window !== 'undefined') return;

		const scope = await resolveScopeOnServer();
		if (scope) throw redirect({ to: '/live-in-club' });
	},
	component: LoginPage,
});
